
import { Link } from "react-scroll";

/*--------------------
* About Section
----------------------*/
export default function About() {
    return (
        <>
            <section className="section">
                <div className="container">
                    <div className="grid lg:grid-cols-12 grid-cols-1 items-center">
                        <div className="lg:col-span-6 text-center mb-[50px] lg:mb-0">
                            <img className="mx-auto" src="img/gif-about-dis.gif" title="Banner" alt="Banner" />
                        </div>
                        <div className="lg:col-span-6 lg:pl-12">
                            <h3 className="font-[600] text-[26px] md:text-[40px] leading-[1.2] text-black mb-[25px]">Yo soy DIS, apasionada por el Diseño</h3>
                            <p className="text-[16px] md:text-[18px]">Un mundo de colores, formas y texturas invade mi mente, me encanta explorar la posibilidad de crear experiencias visuales únicas, atractivas y con una experiencia de usuario intuitiva. ¿Qué tienes en mente? Estoy lista para transformar tus ideas, y de la mano de DEV, crear un sitio web que refleje tu identidad y tus objetivos.</p>
                            {/* <div className="grid grid-cols-12 pt-5">
                                <div className="col-span-6 sm:col-span-4">
                                    <h5 className="text-[26px] text-orange-600 font-[600]">285+</h5>
                                    <span>Projet Completed</span>
                                </div>
                                <div className="col-span-6 sm:col-span-4">
                                    <h5 className="text-[26px] text-orange-600 font-[600]">190+</h5>
                                    <span>Happy Clients</span>
                                </div>
                            </div> */}
                            <div className="pt-6">
                                <Link className="px-btn px-btn-theme mr-4" to="contactus">Contactame</Link>
                                <Link className="px-btn px-btn-dark" to="portfolio">Portafolio</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section">
                <div className="container">
                    <div className="grid lg:grid-cols-12 grid-cols-1 items-center">
                    <div className="lg:col-span-6 lg:pl-12">
                            <h3 className="font-[600] text-[26px] md:text-[40px] leading-[1.2] text-black mb-[25px]">Yo soy DEV, apasionado por el Desarrollo y la programación</h3>
                            <p className="text-[16px] md:text-[18px]">Mi pasión por la programación y el desarrollo web me llevan a crear soluciones eficientes y atractivas. Con una interfaz intuitiva y de la mano de DIS con un diseño atractivo, te ayudo a transformar tu negocio para aprovechar las ventajas de la tecnología.</p>
                            {/* <div className="grid grid-cols-12 pt-5">
                                <div className="col-span-6 sm:col-span-4">
                                    <h5 className="text-[26px] text-orange-600 font-[600]">285+</h5>
                                    <span>Projet Completed</span>
                                </div>
                                <div className="col-span-6 sm:col-span-4">
                                    <h5 className="text-[26px] text-orange-600 font-[600]">190+</h5>
                                    <span>Happy Clients</span>
                                </div>
                            </div> */}
                            <div className="pt-6 mb-4">
                                <Link className="px-btn px-btn-theme mr-4" to="contactus">Contáctame</Link>
                                <Link className="px-btn px-btn-dark" to="portfolio">Portafolio</Link>
                            </div>
                        </div>
                        <div className="lg:col-span-6 text-center mb-[50px] lg:mb-0">
                            <img className="mx-auto" src="img/gif-about-dev.gif" title="Banner" alt="Banner" />
                        </div>
                        
                    </div>
                </div>
            </section>
        </>
    );
}
